import * as CurrentActionTypes from '../../types/current';

export default function current(state = {}, action = {}) {
    switch (action.type) {
        case CurrentActionTypes.SET_CURRENT_USER_ID: {
            return { ...state, userId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_COLLABORATOR_ID: {
            return { ...state, collaboratorId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_FILE_ID: {
            return { ...state, fileId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_FILERR_ID: {
            return { ...state, filerrId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_GROUP_ID: {
            return { ...state, groupId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_COMMENT_ID: {
            return { ...state, commentId: action.payload };
        }

        case CurrentActionTypes.SET_CURRENT_TIMECODE: {
            return { ...state, timecode: action.payload };
        }

        default: {
            return state;
        }
    }
}
